export const en = {
    'audip-genres-title': 'Genres'
};
